import React, { useEffect, useRef, useState } from "react";
import { Button, Form, Space, Spin, Col } from "antd";
import OTPInput from "otp-input-react";
import { useTranslation } from "react-i18next";
import { postRequest } from "../axios";
import { SuccessNotificationMsg } from "../utils/Notifications";
import { loadingIcon } from "../utils/Helper";
import PropTypes from "prop-types";
const VerifyOtpModal = ({
  handleCancel,
  OTP,
  setOTP,
  state,
  setState,
  seconds,
  setSeconds,
  minutes,
  setMinutes,
  handleSendOtpEmail,
  setVerificationResultEmail,
  setVerifyEmailButtonView,
}) => {
  const { t } = useTranslation();
  const formRef = useRef();

  const [apiLoading, setApiLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const initialState = {
    email: state.email ? state.email : null,
    email_otp: OTP,
  };

  const [verifyState, setVerifyState] = useState(initialState);

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setSeconds(30);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds, minutes]);

  const handleSubmit = async () => {
    try {
      setBtnLoading(true);
      const apiResponse = await postRequest(
        "verified-otp/email-otp-verifed/",
        verifyState
      );
      console.log("apiiiiiiii", apiResponse);
      if (apiResponse.data.success) {
        setVerificationResultEmail("success");
        setVerifyEmailButtonView(false);
        setState((prevState) => ({
          ...prevState,
          email_verified: true,
        }));
        setVerifyState(initialState);
        SuccessNotificationMsg("Verified Successfully");
        handleCancel();
      }
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        email_verified: false,
      }));

      setVerificationResultEmail("");
      handleCancel();
      setVerifyEmailButtonView(true);
    } finally {
      setBtnLoading(false);
    }
  };
  const handleOtpChange = (value) => {
    setOTP(value);
    setVerifyState((prevState) => ({
      ...prevState,
      email: state.email ? state.email : null,
      email_otp: value,
    }));
  };
  const handelResendClick = async () => {
    setOTP(null);
    handleSendOtpEmail();
  };

  return (
    <Spin spinning={apiLoading} indicator={loadingIcon}>
      <Form onFinish={handleSubmit} ref={formRef}>
        <label>OTP has been sent on {state.email}</label>

        <div className="modelotp">
          <div className="Otp-Input-Box">
            <OTPInput
              value={OTP}
              onChange={(value) => handleOtpChange(value)}
              autoFocus
              OTPLength={4}
              otpType="number"
              disabled={false}
            />
          </div>

          <Button
            type="primary"
            htmlType="submit"
            loading={btnLoading}
            className="GradiantBtn mt-2"
          >
            {t("verify")}
          </Button>

          <Col className="VerifyOTP-Options mt-2">
            <Space>
              {seconds > 0 || minutes > 0 ? (
                <p style={{ margin: 0 }}>
                  Time Remaining: {minutes < 10 ? `0${minutes}` : minutes}:
                  {seconds < 10 ? `0${seconds}` : seconds}
                </p>
              ) : (
                <p style={{ margin: 0 }}>{t("didnotreceived")}</p>
              )}
              <Button
                type="link"
                onClick={handelResendClick}
                loading={apiLoading}
                style={{
                  color: seconds > 0 || minutes > 0 ? "GrayText" : "#094E8F",
                }}
                disabled={seconds > 0 || minutes > 0}
                danger
              >
                {t("resendOTP")}
              </Button>
            </Space>
          </Col>
        </div>
      </Form>
    </Spin>
    // </Modal>
  );
};

VerifyOtpModal.propTypes = {
  id: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  OTP: PropTypes.func.isRequired,
  setOTP: PropTypes.func.isRequired,
  onClose: PropTypes.number,
  visible: PropTypes.bool,
  state: PropTypes.func.isRequired,
  setState: PropTypes.func.isRequired,
  setMinutes: PropTypes.func.isRequired,
  setSeconds: PropTypes.func.isRequired,
  seconds: PropTypes.func.isRequired,
  minutes: PropTypes.func.isRequired,
  handleSendOtpEmail: PropTypes.func.isRequired,
  setVerificationResultEmail: PropTypes.func.isRequired,
  setVerifyEmailButtonView: PropTypes.func.isRequired,
};
export default VerifyOtpModal;
